
const getCountries = function () {
    return {
        '30013' : 'Afganistán',
        '30014' : 'Albania',
        '30092' : 'Alemania',
        '30017' : 'Andorra',
        '30018' : 'Angola',
        '30019' : 'Anguila',
        '30020' : 'Antigua y Barbuda',
        '30160' : 'Antillas Holandesas',
        '30189' : 'Arabia Saudi',
        '30015' : 'Argelia',
        '30021' : 'Argentina',
        '30022' : 'Armenia',
        '30023' : 'Aruba',
        '30024' : 'Australia',
        '30025' : 'Austria',
        '30026' : 'Azerbaiyán',
        '30027' : 'Bahamas',
        '30028' : 'Bahréin',
        '30029' : 'Bangladesh',
        '30030' : 'Barbados',
        '30033' : 'Belice',
        '30034' : 'Benin',
        '30035' : 'Bermudas',
        '30031' : 'Bielorrusia',
        '30037' : 'Bolivia',
        '122955' : 'Bonaire',
        '30038' : 'Bosnia y Herzegovina',
        '30039' : 'Botsuana',
        '30040' : 'Brasil',
        '30043' : 'Brunéi',
        '30044' : 'Bulgaria',
        '30045' : 'Burkina Faso',
        '30046' : 'Burundi',
        '30036' : 'Bután',
        '30032' : 'Bélgica',
        '30050' : 'Cabo Verde',
        '30047' : 'Camboya',
        '30048' : 'Camerún',
        '30049' : 'Canadá',
        '30053' : 'Chad',
        '30054' : 'Chile',
        '30055' : 'China',
        '30067' : 'Chipre',
        '30056' : 'Christmas Island',
        '30234' : 'Ciudad del Vaticano',
        '30058' : 'Colombia',
        '30059' : 'Comoras',
        '30168' : 'Corea del Norte',
        '30199' : 'Corea del Sur',
        '30064' : 'Costa de Marfil',
        '30063' : 'Costa Rica',
        '30065' : 'Croacia',
        '30066' : 'Cuba',
        '118261' : 'CuraÇao',
        '30069' : 'Dinamarca',
        '30072' : 'Dominica',
        '30075' : 'Ecuador',
        '30076' : 'Egipto',
        '30077' : 'El Salvador',
        '30228' : 'Emiratos Árabes Unidos',
        '30079' : 'Eritrea',
        '30194' : 'Eslovaquia',
        '30195' : 'Eslovenia',
        '30200' : 'España',
        '30230' : 'Estados Unidos',
        '30080' : 'Estonia',
        '30081' : 'Etiopí­a',
        '30177' : 'Filipinas',
        '30085' : 'Finlandia',
        '30084' : 'Fiyi',
        '30086' : 'Francia',
        '30089' : 'Gabón',
        '30090' : 'Gambia',
        '30091' : 'Georgia',
        '30093' : 'Ghana',
        '30094' : 'Gibraltar',
        '30097' : 'Granada',
        '30095' : 'Grecia',
        '30096' : 'Groenlandia',
        '30098' : 'Guadalupe',
        '30099' : 'Guam',
        '30100' : 'Guatemala',
        '30087' : 'Guayana Francesa',
        '30102' : 'Guinea',
        '30101' : 'Guinea-Bissáu',
        '30078' : 'Guinea Ecuatorial',
        '30103' : 'Guyana',
        '30104' : 'Haití­',
        '30159' : 'Holanda',
        '30105' : 'Honduras',
        '30106' : 'Hong Kong',
        '30107' : 'Hungrí­a',
        '30109' : 'India',
        '30110' : 'Indonesia',
        '30112' : 'Iraq',
        '30113' : 'Irlanda',
        '30111' : 'Irán',
        '30108' : 'Islandia',
        '30167' : 'Isla Norfolk',
        '30051' : 'Islas Caimán',
        '30057' : 'Islas Cocos',
        '30062' : 'Islas Cook',
        '30082' : 'Islas Feroe',
        '30083' : 'Islas Malvinas',
        '30141' : 'Islas Marianas del Norte',
        '30142' : 'Islas Marshall',
        '30178' : 'Islas Pitcairn',
        '30196' : 'Islas Salomón',
        '30224' : 'Islas Turcas y Caicos',
        '30231' : 'Islas Ví­rgenes Americanas',
        '30042' : 'Islas Ví­rgenes Británicas',
        '30114' : 'Israel',
        '30115' : 'Italia',
        '30116' : 'Jamaica',
        '30117' : 'Japón',
        '30118' : 'Jordania',
        '30119' : 'Kazajistán',
        '30120' : 'Kenia',
        '30123' : 'Kirguistán',
        '30121' : 'Kiribati',
        '104019' : 'Kosovo',
        '30122' : 'Kuwait',
        '30124' : 'Laos',
        '30127' : 'Lesoto',
        '30125' : 'Letonia',
        '30128' : 'Liberia',
        '30129' : 'Libia',
        '30130' : 'Liechtenstein',
        '30131' : 'Lituania',
        '30132' : 'Luxemburgo',
        '30126' : 'Lí­bano',
        '30133' : 'Macao',
        '30134' : 'Macedonia',
        '30135' : 'Madagascar',
        '30137' : 'Malasia',
        '30136' : 'Malawi',
        '30138' : 'Maldivas',
        '30140' : 'Malta',
        '30139' : 'Malí­',
        '30153' : 'Marruecos',
        '30143' : 'Martinica',
        '30145' : 'Mauricio',
        '30144' : 'Mauritania',
        '30146' : 'Mayotte',
        '30148' : 'Micronesia',
        '30149' : 'Moldavia',
        '30151' : 'Mongolia',
        '89406' : 'Montenegro',
        '30152' : 'Montserrat',
        '30154' : 'Mozambique',
        '30155' : 'Myanmar',
        '30147' : 'México',
        '30150' : 'Mónaco',
        '30156' : 'Namibia',
        '30157' : 'Nauru',
        '30158' : 'Nepal',
        '30163' : 'Nicaragua',
        '30165' : 'Nigeria',
        '30166' : 'Niue',
        '30169' : 'Noruega',
        '30161' : 'Nueva Caledonia',
        '30162' : 'Nueva Zelanda',
        '30164' : 'Ní­ger',
        '30170' : 'Omán',
        '30171' : 'Pakistán',
        '30172' : 'Palau',
        '104013' : 'Palestina',
        '30173' : 'Panamá',
        '30174' : 'Papúa Nueva Guinea',
        '30175' : 'Paraguay',
        '30176' : 'Perú',
        '30088' : 'Polinesia Francesa',
        '30179' : 'Polonia',
        '30180' : 'Portugal',
        '30181' : 'Puerto Rico',
        '30182' : 'Qatar',
        '30041' : 'Reino Unido',
        '30052' : 'República Centroafricana',
        '30068' : 'República Checa',
        '30060' : 'República del Congo',
        '30061' : 'República Democrática del Congo',
        '30073' : 'República Dominicana',
        '30183' : 'Reunión',
        '30186' : 'Ruanda',
        '30184' : 'Rumaní­a',
        '30185' : 'Rusia',
        '122965' : 'Saba',
        '30238' : 'Samoa',
        '30016' : 'Samoa Americana',
        '122961' : 'San Bartolomé',
        '30203' : 'San Cristóbal y Nieves',
        '122963' : 'San Eustaquio',
        '30187' : 'San Marino',
        '118282' : 'San Martí­n',
        '30205' : 'San Pedro y Miquelón',
        '30202' : 'Santa Helena',
        '30204' : 'Santa Lucí­a',
        '30188' : 'Santo Tomé y Prí­ncipe',
        '30206' : 'San Vicente y las Granadinas',
        '30190' : 'Senegal',
        '30240' : 'Serbia',
        '30191' : 'Seychelles',
        '30192' : 'Sierra Leona',
        '30193' : 'Singapur',
        '118283' : 'Sint Maarten',
        '30212' : 'Siria',
        '30197' : 'Somalia',
        '30201' : 'Sri Lanka',
        '30209' : 'Suazilandia',
        '30198' : 'Sudáfrica',
        '30207' : 'Sudán',
        '108793' : 'Sudán del Sur',
        '30210' : 'Suecia',
        '30211' : 'Suiza',
        '30208' : 'Surinam',
        '30216' : 'Tailandia',
        '30213' : 'Taiwán',
        '30215' : 'Tanzania',
        '30214' : 'Tayikistán',
        '30074' : 'Timor Oriental',
        '30217' : 'Togo',
        '93888' : 'Tokelau',
        '30218' : 'Tonga',
        '30219' : 'Trinidad y Tobago',
        '30223' : 'Turkmenistán',
        '30221' : 'Turquí­a',
        '30225' : 'Tuvalu',
        '30220' : 'Túnez',
        '30227' : 'Ucrania',
        '30226' : 'Uganda',
        '30229' : 'Uruguay',
        '30232' : 'Uzbekistán',
        '30233' : 'Vanuatu',
        '30235' : 'Venezuela',
        '30236' : 'Vietnam',
        '30237' : 'Wallis y Futuna',
        '30239' : 'Yemen',
        '30071' : 'Yibuti',
        '30241' : 'Zambia',
        '30242' : 'Zimbabue',
    };
}

export default {
    getCountries
};
